module.exports = __webpack_public_path__ + "images/152616392032d54374a199474ea31425.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro_video/sara_mobile.jpg
// module id = 138
// module chunks = 24